import { PlayerEnvironment } from '../../player_environment';
import createElement from '@javascripts/utils/create_element';
import SeasonPanel from './season_panel';
import EpisodePanel from './episode_panel';
import getElementPositionRelativeToParent from '@javascripts/utils/get_element_position_relative_to_parent';
import { PlayerAhoyEvent } from '../../player_ahoy_event';
import ElementAdapter from '@javascripts/adapters/element_adapter';

export default class EpisodeChooser {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._isShowing = false;
    this._container = null;
    this._containerWidth = 400;
    this._episodePanel = new EpisodePanel({ data });
    this._seasonPanel = new SeasonPanel({ data, episodePanel: this._episodePanel });
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  episodePanel() {
    return this._episodePanel;
  }

  seasonPanel() {
    return this._seasonPanel;
  }

  controlBar() {
    return new ElementAdapter(this.tech().controlBar().el());
  }

  shouldInit() {
    return (
      this.data().episodesList().length !== 0 &&
      this.data().embed() === 'false' &&
      PlayerEnvironment.isMobileSite() === false
    )
  }

  createEpisodeChooser() {
    this._container = createElement(`<div class="episode-chooser"></div>`);
    this._container.appendChild(this.seasonPanel().dom());
    this._container.appendChild(this.episodePanel().dom());

    this._container.onclick = (e) => {
      e.stopPropagation();
    };

    return this._container;
  }

  init() {
    this.setAhoyEventGlobalProperties();
    this.appendEpisodeChooser();
    this.bindEventToggle();
    this.bindFullscreenChange();
    this.bindGlobalClick();
    this.bindOnUserinactive();
  }

  appendEpisodeChooser() {
    this.controlBar().appendChild(this.createEpisodeChooser());
  }

  bindEventToggle() {
    this.tech().on('toggle-episode-chooser', (e) => {
      this.setEpisodeChooserPosition(e);

      if (this._isShowing) {
        this.hideContainer();
      } else {
        this.episodePanel().showEpisodeFromSeason({
          id: this.data().seasonId(),
          name: this.data().seasonName()
        });
        this.showContainer();
      }
    });
  }

  setEpisodeChooserPosition(e) {
    const button_episode_chooser = e.data.event.currentTarget;
    const position = getElementPositionRelativeToParent(button_episode_chooser);

    this._container.style.bottom = (this.controlBar().clientHeight() + 16) + 'px';
    this._container.style.left = (position.x - this._containerWidth + button_episode_chooser.clientWidth) + 'px';
  }

  showContainer() {
    this._isShowing = true;
    this._container.classList.add('is-active');
    this.sendEvent({ action: 'open' });
    this.tech().trigger('vp-episodes-list-open');
  }

  hideContainer() {
    this._isShowing = false;
    this._container.classList.remove('is-active');
    this.sendEvent({ action: 'close' });
    this.tech().trigger('vp-episodes-list-close');
  }

  bindFullscreenChange() {
    this.tech().on('fullscreenchange', () => {
      if (this._isShowing) {
        this.hideContainer();
      }
    });
  }

  bindGlobalClick() {
    this.tech().on('click', () => {
      if (this._isShowing) {
        this.hideContainer();
      }
    });
  }

  bindOnUserinactive() {
    this.tech().on('userinactive', () => {
      if (!this.tech().paused()) {
        this.hideContainer();
      }
    });
  }

  sendEvent({ action }) {
    PlayerAhoyEvent.sendEpisodeList({
      play_uuid: this.data().playUUID(),
      current_video_id: this.data().videoId(),
      next_video_id: null,
      action: action
    });
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
